function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2539 5.87238H17.1835V2.53906C17.1835 1.13902 16.0445 0 14.6444 0H13.2539V5.87238Z",
  fill: "#0F2E43"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2539 7.04492H17.1835V12.9564H13.2539V7.04492Z",
  fill: "#0F2E43"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2539 14.127V19.9993H14.6444C16.0445 19.9993 17.1835 18.8603 17.1835 17.4603V14.127H13.2539Z",
  fill: "#0F2E43"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.00391 9.45312C6.84528 9.45312 7.52734 8.77106 7.52734 7.92969C7.52734 7.08832 6.84528 6.40625 6.00391 6.40625C5.16253 6.40625 4.48047 7.08832 4.48047 7.92969C4.48047 8.77106 5.16253 9.45312 6.00391 9.45312Z",
  fill: "#0F2E43"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.0032 10.625C4.69812 10.625 3.63273 11.671 3.60156 12.9688H8.40488C8.37367 11.671 7.30828 10.625 6.0032 10.625Z",
  fill: "#0F2E43"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0827 0H0V20H12.0827V0ZM3.30691 7.92969C3.30691 6.44348 4.51602 5.23438 6.00223 5.23438C7.48844 5.23438 8.69754 6.44348 8.69754 7.92969C8.69754 8.7268 8.34941 9.44391 7.79758 9.93781C8.86051 10.5579 9.57644 11.7105 9.57644 13.0273V14.1406H2.42801V13.0273C2.42801 11.7105 3.14391 10.5579 4.20687 9.93781C3.65504 9.44391 3.30691 8.7268 3.30691 7.92969Z",
  fill: "#0F2E43"
});

var SvgContactinfo = function SvgContactinfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactinfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contactinfo.102e1965.svg";
export { ForwardRef as ReactComponent };